import React from "react";

export const Loader = () => {
  return (
 /* From Uiverse.io by sahilxkhadka */ 
<div className="flex-col gap-4 w-full flex items-center justify-center">
  <div
    className="w-20 h-20 border-4 border-transparent text-brown-500 text-4xl animate-spin flex items-center justify-center border-t-brown-500 rounded-full"
  >
    <div
      className="w-16 h-16 border-4 border-transparent text-brown-300 text-2xl animate-spin flex items-center justify-center border-t-brown-300 rounded-full"
    ></div>
  </div>
</div>

  );
};
